import React from 'react';
import { motion } from 'framer-motion';
import { Server, Cpu, Layers, ArrowUp } from 'lucide-react';

const Slide12Ask = () => {
    return (
        <div className="w-full h-full bg-background p-8 lg:p-16 flex flex-col items-center justify-center relative">
            {/* Background Grid Texture */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
            />
            <motion.div className="text-center mb-12">
                <h2 className="text-4xl lg:text-6xl font-bold mb-4">Autonomous Financial Assistant a.k.a ADI</h2>
                <p className="text-xl text-muted-foreground">Technical Architecture</p>
            </motion.div>

            {/* Stack Diagram */}
            <div className="w-full max-w-4xl flex flex-col gap-4">

                {/* Top Layer: UI/Output */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6 }}
                    className="p-6 bg-card border border-primary/50 rounded-xl flex items-center justify-between shadow-[0_0_20px_rgba(0,255,0,0.1)]"
                >
                    <div className="flex items-center gap-4">
                        <Layers className="w-8 h-8 text-primary" />
                        <div>
                            <h3 className="text-xl font-bold text-white">Decision Cards (UI)</h3>
                            <p className="text-sm text-muted-foreground">Context-Aware, Explainable Recommendations</p>
                        </div>
                    </div>
                    <div className="px-4 py-1 bg-primary text-black text-xs font-bold rounded-full">Output</div>
                </motion.div>

                {/* Arrows */}
                <div className="flex justify-center">
                    <ArrowUp className="w-6 h-6 text-primary/50 animate-bounce" />
                </div>

                {/* Middle Layer: Reasoning Agents */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                    className="grid grid-cols-2 gap-4"
                >
                    <div className="p-6 bg-card/50 border border-border rounded-xl">
                        <h4 className="font-bold text-white mb-2 flex items-center gap-2"><Cpu className="w-4 h-4 text-primary" /> Risk Agent</h4>
                        <p className="text-xs text-muted-foreground">Dynamic risk profiling based on market & user behavior.</p>
                    </div>
                    <div className="p-6 bg-card/50 border border-border rounded-xl">
                        <h4 className="font-bold text-white mb-2 flex items-center gap-2"><Cpu className="w-4 h-4 text-primary" /> Goal Agent</h4>
                        <p className="text-xs text-muted-foreground">Path optimization for short & long term goals.</p>
                    </div>
                </motion.div>

                {/* Arrows */}
                <div className="flex justify-center">
                    <ArrowUp className="w-6 h-6 text-primary/50 animate-bounce" />
                </div>

                {/* Bottom Layer: Data Ingestion */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="p-6 bg-card/30 border border-dashed border-border rounded-xl flex items-center justify-between"
                >
                    <div className="flex items-center gap-4">
                        <Server className="w-8 h-8 text-muted-foreground" />
                        <div>
                            <h3 className="text-xl font-bold text-muted-foreground">Data Ingestion Layer</h3>
                            <p className="text-sm text-muted-foreground">Bank APIs (AA), SMS Parsing, User Inputs</p>
                        </div>
                    </div>
                    <div className="px-4 py-1 bg-muted text-muted-foreground text-xs font-bold rounded-full">Input</div>
                </motion.div>

            </div>
        </div>
    );
};

export default Slide12Ask;